const contents = [
    'ช่วง High Season จะขึ้นราคาเท่าไหร่ดี ?',
    'ลูกค้าเยอะ จะขึ้นราคาสินค้าหน่อยดีมั้ย ?',
    'แล้วจะขึ้นราคายังไงให้ไม่น่าเกลียด ?'
]

export default contents;